import { Activities, attraqtTracker } from './attraqtTracker';

function attraqtTrackerPurchase(): void {
  const { entries, orderId, orderCreationTimestamp } = window.globalOrderConfirmation;
  // Note: This is to prevent attraqtTracker from sending the same purchase event multiple times.
  // This approach is similar to google analytics' approach in googleAnalyticsForOrderConfrimationPage.tag.
  const ATOID = 'atoid';
  const attraqtTrackerOrderIdCookie = getCookie(ATOID);
  const day = 1000 * 60 * 60 * 24;
  const millisecondsSinceOrder = Date.now() - orderCreationTimestamp;
  const isRecentOrder = millisecondsSinceOrder < day;

  if (attraqtTrackerOrderIdCookie !== orderId && isRecentOrder) {
    entries.forEach((entry) => {
      const {
        attraqt: { fhProductCode },
        price,
        quantity,
        currency
      } = entry;
      attraqtTracker({
        action: Activities.PURCHASE,
        target: {
          product: fhProductCode
        },
        metadata: {
          orderId,
          price: price * 100,
          quantity,
          currency
        }
      });
    });

    const expireOneWeekFromNow = new Date();
    expireOneWeekFromNow.setDate(expireOneWeekFromNow.getDate() + 7);
    document.cookie = `${ATOID}=${orderId}; expires=${expireOneWeekFromNow.toUTCString()}`;
  }

  function getCookie(key: string): string | null {
    const result = new RegExp(`(?:^|; )${encodeURIComponent(key)}=([^;]*)`).exec(document.cookie);
    return result ? result[1] : null;
  }
}

export default attraqtTrackerPurchase;
